import { Analytics } from '../../views/ts/components/Analytics';
import { CookiesConsent } from '../../views/twig/components/CookiesConsent';
import { Carousel } from '../../views/ts/components/Carousel';
import { Collapse } from '../../views/ts/components/Collapse';
import { Dropdown } from '../../views/ts/components/Dropdown';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { ScrollSpy } from '../../views/ts/components/ScrollSpy';
import { Menu } from '../../views/twig/components/Menu';
import { SingleBook } from '../twig/pages/single-book';
import { FixedFixer } from './components/FixedFixer';
import { FrontPage } from '../twig/pages/front-page';
import { CollapseComponent } from '../twig/components/Collapse';
import { CoverResizer } from './components/CoverResizer';
import { LayoutSwitcher } from '../twig/components/LayoutSwitcher';
import { Header } from '../twig/components/Header/Header';
import { ExternalMedia } from '../twig/components/ExternalMedia';
import { Filters } from '../twig/components/Filters';
import { BookThumbnail } from '../twig/components/BookThumbnail';
(new Analytics()).init();
(new Carousel()).init();
(new Collapse()).init();
(new Dropdown()).init();
(new LazyLoader()).init();
(new ScrollSpy()).init();
(new Menu()).init();
(new SingleBook()).init();
(new FixedFixer).init();
(new FrontPage()).init();
(new CollapseComponent()).init();
(new CoverResizer()).init();
(new LayoutSwitcher()).init();
(new Header()).init();
(new ExternalMedia()).init();
(new Filters()).init();
(new BookThumbnail()).init();
// Always at the end
(new CookiesConsent()).init();
